import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Tree } from 'antd';
import Checkbox from '@lingxi-common-component/sirius-ui/Checkbox';
import IconCard from '@web-common/components/UI/IconCard/index';
import { getIn18Text, FLOLDER } from 'api';
import classnames from 'classnames';
import styles from './FolderSelectModal.module.scss';
import { MailClassifyActions, useActions, useAppSelector } from '@web-common/state/createStore';
import { folderIdIsRealFolder } from '@web-mail/util';
import { isMainAccount } from '@web-common/components/util/contact';
const SCOPE_SENT_FOLDERS = [FLOLDER.SENT];
const RECEIVE_SCOPE_DEFAULT_UNCHECKED_FOLDERS = [FLOLDER.SENT];
const FolderSelectModal = props => {
    const { parentModalType, _account, isScopeSent } = props;
    const [checkAll, setCheckAll] = useState(false);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const mailTreeStateMap = useAppSelector(state => state.mailReducer.mailTreeStateMap);
    const { selectedFolders, isScopeSent: reduxIsScopeSent } = useAppSelector(state => state.mailClassifyReducer);
    const { showFolderSelectModal, folderExecFun } = useAppSelector(state => state.mailClassifyReducer);
    const effectiveIsScopeSent = reduxIsScopeSent !== null && reduxIsScopeSent !== void 0 ? reduxIsScopeSent : isScopeSent;
    const { setShowFolderSelectModal, setSelectedFolders } = useActions(MailClassifyActions);
    const treeData = useMemo(() => {
        var _a;
        let mainList = [];
        if (!_account || isMainAccount(_account)) {
            mainList = mailTreeStateMap.main.mailFolderTreeList;
        }
        else {
            mainList = ((_a = mailTreeStateMap[_account]) === null || _a === void 0 ? void 0 : _a.mailFolderTreeList) || [];
        }
        if (!mainList || (mainList === null || mainList === void 0 ? void 0 : mainList.length) < 1)
            return [];
        const transToTreeNode = (modelList) => {
            if (!modelList || modelList.length === 0)
                return [];
            const filterList = [];
            modelList.forEach((item) => {
                var _a, _b, _c;
                const fid = (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId;
                if (folderIdIsRealFolder(fid) && (!effectiveIsScopeSent || SCOPE_SENT_FOLDERS.includes(fid))) {
                    filterList.push(Object.assign(Object.assign({}, item), { title: (_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.mailBoxName, key: (_c = item === null || item === void 0 ? void 0 : item.entry) === null || _c === void 0 ? void 0 : _c.mailBoxId, children: transToTreeNode((item === null || item === void 0 ? void 0 : item.children) || []) }));
                }
            });
            return filterList;
        };
        return transToTreeNode(mainList);
    }, [_account, mailTreeStateMap, effectiveIsScopeSent]);
    const getFolderKeys = (excludeReceiveDefaultUncheckedFolders = false) => {
        var _a;
        let mainList = [];
        if (!_account || isMainAccount(_account)) {
            mainList = mailTreeStateMap.main.mailFolderTreeList;
        }
        else {
            mainList = ((_a = mailTreeStateMap[_account]) === null || _a === void 0 ? void 0 : _a.mailFolderTreeList) || [];
        }
        if (!mainList || (mainList === null || mainList === void 0 ? void 0 : mainList.length) < 1) {
            return [];
        }
        let selectedKeys = [];
        const transToTreeNode = (modelList) => {
            if (!modelList || modelList.length === 0)
                return;
            modelList.forEach((item) => {
                var _a, _b, _c, _d;
                if (folderIdIsRealFolder((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) &&
                    (!effectiveIsScopeSent || SCOPE_SENT_FOLDERS.includes((_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId)) &&
                    (!excludeReceiveDefaultUncheckedFolders || effectiveIsScopeSent || !RECEIVE_SCOPE_DEFAULT_UNCHECKED_FOLDERS.includes((_c = item === null || item === void 0 ? void 0 : item.entry) === null || _c === void 0 ? void 0 : _c.mailBoxId))) {
                    selectedKeys.push((_d = item === null || item === void 0 ? void 0 : item.entry) === null || _d === void 0 ? void 0 : _d.mailBoxId);
                    transToTreeNode((item === null || item === void 0 ? void 0 : item.children) || []);
                }
            });
        };
        transToTreeNode(mainList);
        return selectedKeys;
    };
    const checkAllAction = () => {
        const selectedKeys = getFolderKeys();
        setCheckedKeys(selectedKeys);
        setCheckAll(true);
    };
    const showConflictWarning = effectiveIsScopeSent || checkedKeys.some(key => Number(key) === FLOLDER.SENT);
    const conflictWarningText = effectiveIsScopeSent ? getIn18Text('RUTONGYIFENGLISHIYIFASONG') : getIn18Text('YIFASONGZHONGDELISHIYOUJIAN');
    const onCheckAllChange = (e) => {
        const { checked } = e.target;
        setCheckAll(checked);
        if (checked) {
            checkAllAction();
        }
        else {
            setCheckedKeys([]);
            setCheckAll(false);
        }
    };
    const handleCheck = (keys, info) => {
        const newCheckedKeys = Array.isArray(keys) ? keys : (keys === null || keys === void 0 ? void 0 : keys.checked) || [];
        setCheckedKeys(newCheckedKeys);
        const allFolderKeys = getFolderKeys();
        const checkedSet = new Set(newCheckedKeys);
        const allChecked = allFolderKeys.length > 0 && allFolderKeys.every(key => checkedSet.has(key));
        setCheckAll(allChecked);
    };
    const confirmExec = () => {
        folderExecFun && folderExecFun(checkedKeys);
        clearReduxData();
        setShowFolderSelectModal(false);
    };
    const onCancel = () => {
        clearReduxData();
        setShowFolderSelectModal(false);
    };
    const clearReduxData = () => {
        setSelectedFolders(undefined);
        setCheckedKeys([]);
    };
    useEffect(() => {
        if (showFolderSelectModal) {
            if (!selectedFolders) {
                setCheckedKeys([]);
                setCheckAll(false);
            }
            else {
                setCheckedKeys(selectedFolders);
            }
        }
    }, [showFolderSelectModal, selectedFolders, _account, effectiveIsScopeSent]);
    return (React.createElement(Modal, { width: 400, className: `${styles.folderSelectModal} extheme`, title: getIn18Text('QINGXUANZEYAOZHIHGZDWJJ'), visible: showFolderSelectModal, wrapClassName: styles.folderSelectModalWrap, okText: getIn18Text(parentModalType === 'edit' ? 'QUEREN' : 'LIJIZHIXING'), maskClosable: true, cancelText: getIn18Text('QUXIAO'), onCancel: onCancel, okButtonProps: { disabled: (checkedKeys === null || checkedKeys === void 0 ? void 0 : checkedKeys.length) === 0 }, onOk: () => confirmExec(), centered: true, closable: false, destroyOnClose: true },
        React.createElement("div", { className: styles.contArea },
            React.createElement("div", { className: styles.checkAllArea },
                React.createElement(Checkbox, { onChange: onCheckAllChange, checked: checkAll },
                    getIn18Text('YIXUAN'),
                    "(",
                    (checkedKeys === null || checkedKeys === void 0 ? void 0 : checkedKeys.length) || 0,
                    ")")),
            showConflictWarning && (React.createElement("div", { className: styles.conflictWarning },
                React.createElement("span", { className: styles.warningIconWrapper },
                    React.createElement(IconCard, { type: "info", stroke: "#F74F4F", width: "12" })),
                React.createElement("span", null, conflictWarningText))),
            React.createElement("div", { className: classnames('sirius-scroll', styles.treeArea) },
                React.createElement(Tree, { treeData: treeData, checkable: true, checkStrictly: true, checkedKeys: checkedKeys, onCheck: handleCheck })))));
};
export default FolderSelectModal;
